// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header__content[data-v-beea2538]{border-bottom:2px solid #c4c4c4}.menu_item[data-v-beea2538]{text-decoration:none;color:#000}", ""]);
// Exports
module.exports = exports;
